export interface BuildInfo {
  version: string;
  builtAt: string;
}

export const BUILD_INFO: BuildInfo = {
  version: '2026.10.29.082314',
  builtAt: '2026-10-29T08:23:14Z',
};
